import React, { useState , useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Modal, ModalBody, ModalHeader, Row, Col, ListGroupItem, ListGroup, Input, Label} from 'reactstrap';
import { Create_New_Group, get_payment_summary, Get_Plans, update_group_info_ } from '../../../slices/thunks';
import { useSelector } from 'react-redux';
import Loader from '../Loader';
import config from '../../../config';


const Update_Group_Details = () => {
    const {  No_Group_Created  }  = useSelector((state)=>state.Group_List)
    const [current_plan_details, setcurrent_plan_details] = useState({})
    const [modal_standard, setmodal_standard] = useState(false);
    const { loading } = useSelector((state)=>state.GroupOwner)
    const [input, setinput] = useState('')
    const dispatch = useDispatch()
    const {PlanName,Plan_Id} = useSelector((state)=>state.Plans.current_plan_details)
    const {plans} = useSelector((state)=>state.Plans)
    const { Group_ID , Group_Name , Token_Allowed , User_Role } = useSelector((state)=> state.GroupOwner.Group_Details)
    const group_details = useSelector((state)=> state.GroupOwner.Group_Details)

    const [group_name, setgroup_name] = useState(Group_Name)
    const [token_allowed, settoken_allowed] = useState(Token_Allowed)


    function tog_standard_CNG() {
        setmodal_standard(!modal_standard);
    }


    useEffect(() => {

        setinput('')
     
    }, [modal_standard, setmodal_standard])


    
    useEffect(() => {
          
        setmodal_standard(No_Group_Created)
        


    },[No_Group_Created])


    // const onClick_create_new_group = () =>{

    //     if(input.trim().length === 0){
    //         return
    //     }
        
    //     dispatch(Create_New_Group({ group_name:input }))

    // }

    useEffect(() => {

        setgroup_name(Group_Name)
        settoken_allowed(Token_Allowed)
        if(!Token_Allowed){
            settoken_allowed(config.general_config.Max_Token_Allowed)
        }

    }, [group_details])


    useEffect(() => {
        dispatch(get_payment_summary())
        dispatch(Get_Plans())
    }, [])


    useEffect(() => {
        const plan_temp = plans?.filter(plan => plan.plan_id === Plan_Id)       
        if(plan_temp){

            setcurrent_plan_details(plan_temp[0])
        }
    }, [plans])
    
    


const onClick_update_group_details = () =>{
    
    dispatch(update_group_info_({ Group_Name:group_name , Token_Allowed:token_allowed , group_id:Group_ID }))

}
    
    
  return (
    <>
    {User_Role === 'Super User'&&<span className="edit_group_pop text-secondary" style={{marginRight : '7px', fontSize : '16px', cursor : 'pointer'}} onClick={() => tog_standard_CNG()}><i className='mdi mdi-lead-pencil'></i></span>
      }
      {/* Default Modal */}
        <Modal id="myModal"
            isOpen={modal_standard}
            toggle={() => {
                tog_standard_CNG();
            }}
        >
            <ModalHeader className="modal-title"
                id="myModalLabel" toggle={() => {
                    tog_standard_CNG();
                }}> 
                UPDATE GROUP
            </ModalHeader>
           
          { loading? <Loader/>:  <><ModalBody>
                <div className='add_new_user_inner'>
                {No_Group_Created && <p className='modal-title' >You need to create a group first before creating a bot</p>}
                    <Row>
                        <Col md={12}>
                            <div className='user_name'>
                                <Label>Group Name</Label>
                              <Input onChange={(e)=>{
                                setgroup_name(e.target.value)

                                }} value={group_name} type='text'/>
                                </div>
                            </Col>
                            <Col md={12}>
                            <div className='user_name mt-30'>
                                <Label>Max Token Allowed / Month</Label>
                              <Input      onChange={(e) => {
                                    // Remove formatting (commas) to handle raw numeric input
                                    const rawValue = e.target.value.replace(/,/g, '');
                                    
                                    // Check if the input is a valid number
                                    if (!isNaN(rawValue)) {
                                    settoken_allowed(parseInt(rawValue, 10) || 0);
                                    }
                                }}  value={token_allowed?.toLocaleString()}  type='text'/>
                                </div>
                            </Col>
                            <Col md={6} style={{marginTop:'25px'}}>
                                <Label>Plan Name </Label>
                                <h5>{PlanName}</h5>
                            </Col>
                            <Col md={6} style={{marginTop:'25px'}}>
                                <Label>Free Tokens</Label>
                                <h5>{current_plan_details?.FreeTokens?.toLocaleString()}</h5>
                            </Col>
                            
                        </Row>    
                        
                    </div>
                </ModalBody>
                <div className="modal-footer">            
                    {/* <Button
                        color="light"
                        onClick={() => {
                            tog_standard_CNG();
                        }}
                    >
                        Close
                    </Button> */}
                    <Button
                    onClick={onClick_update_group_details}
                        color="secondary"
                    >
                        Update Group
                    </Button>
                </div>
            </>}
        </Modal>
    </>
  )
}

export default Update_Group_Details

